// extracted by mini-css-extract-plugin
module.exports = {"Input":"Input_Input__2eInA","Label":"Input_Label__29IXU","InputElement":"Input_InputElement__12_Do","Invalid":"Input_Invalid__Oqmi_"};